import type { ReactElement } from 'react';

export interface KeyHint {
  /** 누를 키 이름(예: 'Esc'). 키 모양 칩으로 보인다. */
  readonly keyName: string;
  readonly label: string;
}

interface KeyHintsProps {
  readonly hints: readonly KeyHint[];
}

/** 그리기·추출 중 쓸 수 있는 키 안내. 문장 속에 묻히지 않도록 키 칩과 굵은 글씨로 보인다. */
export const KeyHints = ({ hints }: KeyHintsProps): ReactElement => (
  <p className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm font-medium">
    {hints.map((hint) => (
      <span key={hint.keyName} className="inline-flex items-center gap-1.5">
        <kbd className="rounded border border-foreground/30 bg-muted px-1.5 py-0.5 font-mono text-xs font-semibold shadow-sm">
          {hint.keyName}
        </kbd>
        {hint.label}
      </span>
    ))}
  </p>
);
